import { css, SerializedStyles } from '@emotion/react';
import { applyFont, tokens } from '@domain-group/fe-brary';

const { colors, spacing, typography } = tokens;

export const container = (inline: boolean): SerializedStyles => css`
  display: flex;
  gap: ${spacing.xxs};
  ${inline
    ? `flex-direction: row; align-items: center; flex-wrap: wrap;`
    : `flex-direction: column; align-items: flex-start;`}
`;

export const summary = css`
  display: flex;
  align-items: center;
  gap: ${spacing.xxs};
`;

const STAR_SIZE = 20;
const STAR_SIZE_INLINE = 16;

export const star = (inline: boolean): SerializedStyles => css`
  flex: none;
  width: ${inline ? STAR_SIZE_INLINE : STAR_SIZE}px;
  height: ${inline ? STAR_SIZE_INLINE : STAR_SIZE}px;
  color: ${colors.warning.trim.hover};
  ${inline && 'margin-bottom: 2px;'}
`;

export const average = (inline: boolean): SerializedStyles => css`
  ${applyFont(inline ? typography.caption : typography.body)}
  color: ${inline
    ? colors.neutral.medium.default
    : colors.neutral.heavy.default};
`;

export const total = css`
  ${applyFont(typography.caption)}
  color: ${colors.neutral.medium.default};
`;

export const attribution = css`
  display: flex;
  align-items: center;
  gap: ${spacing.xxs};
`;

export const attributionLogo = (inline: boolean): SerializedStyles => css`
  ${inline &&
  `
    margin-left: 1px;
    margin-right: -1px;
    margin-top: 4px;

    @media (min-width: 418px) {
      margin-top: 3px;
    }

    @media (min-width: 624px) {
      margin-top: -1px;
    }
  `}
`;

export const tooltip = css`
  ${applyFont(typography.caption)}
  color: ${colors.neutral.surface.default};
  max-width: 320px;
  display: inline-block;
  z-index: 1;
`;

const INFO_ICON_SIZE = 16;

export const infoIcon = css`
  position: relative;
  z-index: 2;
  width: ${INFO_ICON_SIZE}px;
  height: ${INFO_ICON_SIZE}px;
  color: ${colors.neutral.base.default};

  &:hover,
  &:active {
    cursor: pointer;
    color: ${colors.neutral.base.hover};
  }
`;
